import { api } from "api/api";
import { FormValues } from "hooks/client/useRegister.hook";

export const register = async ({ firstName, lastName, phone, password }: FormValues) => {
    const url = "/api/mobile/zenpilates/register";

    return await api.post(url, { firstName, lastName, phone, password });
};
